module.exports = "<div ng-cloak>\r\n    <div class=\"<%= vendorInformation %> <%= vendorName %>\">${facility.contactName}</div>\r\n    <div class=\"<%= vendorInformation %>\">${facility.primaryAddress.displayName}</div>\r\n    <div class=\"<%= vendorInformation %>\">\r\n        <div>${facility.workNumber}</div>\r\n        <div>${facility.emailAddress1}</div>\r\n    </div>\r\n    <gw-fnol-pa-repair-facility-rating rate=\"${facility.score}\"></gw-fnol-pa-repair-facility-rating>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/fnol/pa/components/RepairFacilitiesMap/InfoWindowTemplate.html
// module id = 657
// module chunks = 0